exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".progress-outer {\n  display: flex;\n  width: 30%;\n  height: 19px;\n  margin-bottom: 10px;\n  padding: 4px;\n  text-align: center;\n  background-color: #f4f4f4;\n  border: 1px solid #dcdcdc;\n  color: #fff;\n  border-radius: 20px; }\n\n.progress-inner {\n  min-width: 15%;\n  white-space: nowrap;\n  overflow: hidden;\n  border-radius: 20px;\n  background-color: #1C61B5; }\n\n.progress-inner p {\n  font-size: 0.5em; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/admin/shared/progress-bar/progress-bar.scss
// module id = 274
// module chunks = 0 1